export default __webpack_public_path__ + "static/media/5.3.c726929e.mp4";